import { jsx as p } from "react/jsx-runtime";
import "react";
import { createContext as m } from "./help-center-articles-search6.js";
import "./help-center-articles-search7.js";
import x from "./help-center-articles-search8.js";
const [_, h] = m(), d = ({
  children: e,
  locale: t,
  resultsPageUrl: r,
  applicationName: n,
  logger: o,
  environment: a
}) => {
  const { t: s } = x;
  return /* @__PURE__ */ p(h, { value: {
    locale: t,
    resultsPageUrl: r,
    applicationName: n,
    logger: o,
    environment: a,
    translate: (c) => {
      const i = t?.toLowerCase()?.replace("-", "_") || "en_us";
      return s(`vistaprint:${c}`, { lng: i });
    }
  }, children: e });
};
export {
  h as SearchContext,
  d as SearchContextProvider,
  _ as useSearchContext
};
//# sourceMappingURL=help-center-articles-search3.js.map
